var path = './approvals/approvalActionBar/fileBrowserApprovalActionBar.html';
var html = "<div class=\"top-action-bar\">\n    <add-to-approval-button class=\"menu-button\" enabled=\"true\" selection-manager=\"fileManagerInstance\"></add-to-approval-button>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;